import * as React from 'react'

import Typography from '@material-ui/core/Typography/Typography'
import { Study }  from '../../api'

type Props = Study

export default ({
  school,
  name,
}: Props) => (
  <Typography
    noWrap
    variant={'headline'}
    color={'secondary'}
  >
    {school}
    <Typography
      noWrap
      variant={'subheading'}
    >
      {name}
    </Typography>
  </Typography>
)



// WEBPACK FOOTER //
// ./src/components/molecules/Study.tsx